import { render } from "./RequestResetPassword.vue?vue&type=template&id=6953bc38&scoped=true"
import script from "./RequestResetPassword.vue?vue&type=script&lang=js"
export * from "./RequestResetPassword.vue?vue&type=script&lang=js"

import "./RequestResetPassword.vue?vue&type=style&index=0&id=6953bc38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6953bc38"]])

export default __exports__